import classes from './Tooltip.module.scss';

const Tooltip = ({ classNameChildren, className, children, content, position = 'top-left', type = 'info' }) => {
  const positionTypeClass = `${position}__${type}`;
  const contentClasses = [classes.content, classes[positionTypeClass], 'semibold-14'];

  const contentChildren = [classes.container];

  if (className) {
    contentClasses.push(className);
  }
  if (classNameChildren) {
    contentChildren.push(classNameChildren);
  }

  return (
    <div className={contentChildren.join(' ')}>
      {children}
      <div className={contentClasses.join(' ')}>{content}</div>
    </div>
  );
};

export default Tooltip;
